<template>
  <div class="container-list">
    <div
      class="common-page common-head flex flex1"
      style="margin: 0; justify-content: space-between"
    >
      <div class="common-page common-head-title">
        <i class="icon-tr--detailed" style="padding-right: 5px"></i>
        消防档案管理
      </div>

      <!-- 消防安全基本情况 -->

      <!-- <div class="common-page common-head-end">
                <i class="icon-tr-sign-out"></i>
      </div>-->
    </div>
    <ul class="tab-wrap mt20">
      <li
        :class="`tab-btn ${nowIndex == index && 'active'}`"
        @click="changeTab(index, tab)"
        v-for="(tab, index) in tabList"
      >
        {{ tab.name }}
      </li>
    </ul>

    <div style="width:100%" class="flex">
      <div class="choose" v-if="tabList[nowIndex].id == 0">
        <div>
          <div
            class="areaitem"
            v-for="item in areaList"
            :class="params.dictValue === item.dictValue ? 'mark' : ''"
            @click="chooseArea(item)"
          >
            {{ item.dictLabel }}
          </div>
        </div>
      </div>

      <div class="choose" v-else>
        <div>
          <div
            class="areaitem"
            v-for="item in areaList"
            :class="params1.dictValue === item.dictValue ? 'mark' : ''"
            @click="chooseArea(item)"
          >
            {{ item.dictLabel }}
          </div>
        </div>
      </div>

      <div
        class=""
        style="width:100%;height:39.2vw;overflow:auto"
        v-if="tabList[nowIndex].id == 0"
      >
        <!-- 重点部位 -->
        <importPart
          v-show="params.dictValue == 1"
          v-if="showComp"
          :dictValue="params.dictValue"
        />
        <!-- 报告详情模板 -->
        <reportDetail
          :dict="params.dictType"
          :dictValue="params.dictValue"
          :dictType="1"
          v-if="
            showComp &&
              (params.dictValue == 8 ||
                params.dictValue == 4 ||
                params.dictValue == 5 ||
                params.dictValue == 6)
          "
        />
        <!-- 消防设施 -->
        <fireFacilities
          :dict="params.dictType"
          :dictValue="params.dictValue"
          :dictType="1"
          v-if="showComp && params.dictValue == 9"
        />
        <!-- 消防组织 -->
        <fireGroup
          v-if="params.dictValue == 2 && showComp"
          :dict="params.dictType"
          :dictValue="params.dictValue"
          :dictType="1"
        />

        <!-- 微型消防站 -->
        <fireStation
          v-if="params.dictValue == 3 && showComp"
          :dict="params.dictType"
          :dictValue="params.dictValue"
          :dictType="1"
        />
        <company
          :c_num="$route.query.id"
          v-if="params.dictValue == 7 && showComp"
        />
      </div>
      <!-- 消防安全管理情况 -->

      <div
        class=""
        style="width:100%;height:39.2vw;overflow:auto"
        v-if="tabList[nowIndex].id == 1"
      >
        <reportDetail
          :dict="params1.dictType"
          :dictValue="params1.dictValue"
          :dictType="2"
          v-if="
            !(
              params1.dictValue == 4 ||
              params1.dictValue == 6 ||
              params1.dictValue == 13
            ) && showComp
          "
        />

        <!-- <danger v-if="params1.dictValue==4" :c_num="$route.query.id"></danger> -->

        <dangerRecord
          v-if="params1.dictValue == 4 && showComp"
          :c_num="$route.query.id"
        ></dangerRecord>
        <safeRecord
          :c_num="$route.query.id"
          v-if="params1.dictValue == 6 && showComp"
        />
      </div>
    </div>
  </div>
</template>

<script>
// import unitList from "@/components/unitList";
import danger from "../company/danger";
import dangerRecord from "./components/dangerRecord.vue";
import importPart from "./components/importPart";
import reportDetail from "./components/reportDetail";
import fireFacilities from "./components/fireFacilities";
import fireGroup from "./components/firegroup.vue";
import fireStation from "./components/fireStation.vue";
import company from "../../components/company.vue";
import safeRecord from "./components/safeRecord.vue";
export default {
  components: {
    dangerRecord,
    danger,
    importPart,
    reportDetail,
    fireFacilities,
    fireGroup,
    fireStation,
    safeRecord,
    company,
  },
  inject: ["reload"],

  data() {
    return {
      list: [],
      tabList: [
        { name: "消防安全基本情况", id: 0 },
        { name: "消防安全管理情况", id: 1 },
      ],
      showComp: true,
      cpNum: "",
      nowIndex: 0,
      leftParams: {
        dictType: 1,
      },
      list1: [],
      params: {
        dictValue: "7",
        dictType: "",
      },
      params1: {
        dictValue: "2",
        dictType: "",
      },
      areaList: [],
      erform: {},
      total: 0,
      showDia: false,
      showDia1: false,
      formList: [
        {
          title: "消防重点部位",
          form: "get_emphasis",
          data: [
            { form_name: "zd_name", type: "text", text: "部位名称" },
            { form_name: "zd_address", type: "text", text: "所在位置" },
            { form_name: "zd_nature", type: "text", text: "使用性质" },
            { form_name: "zd_area", type: "text", text: "建筑面积" },

            { form_name: "zd_level", type: "text", text: "耐火等级" },
            {
              form_name: "zd_facility",
              type: "select",
              text: "有无消防设施",
              option: [
                { mc_id: 1, mc_name: "有" },
                { mc_id: 0, mc_name: "无" },
              ],
            },

            { form_name: "zd_duty_name", type: "text", text: "责任人姓名" },

            { form_name: "zd_duty_card", type: "text", text: "身份证号码" },

            { form_name: "zd_duty_phone", type: "text", text: "电话" },
          ],
        },
      ],
    };
  },
  created() {
    this.getDatas();
    // console.log(this.$route.query.view,3333333);
  },
  mounted() {},
  methods: {
    changeTab(index, it) {
      console.log(index, 333);
      this.nowIndex = index;

      this.leftParams.dictType = index == 0 ? 1 : 2;
      this.getDatas();
    },
    resetParams() {
      this.params = {
        dictValue: "7",
        dictType: "",
      };
      this.params1 = {
        dictValue: "1",
        dictType: "",
      };
    },
    chooseArea(it) {
      console.log(it, 2222);
      if (this.tabList[this.nowIndex].id == 0) {
        console.log("jinlai");
        this.params.dictValue = it.dictValue;

        this.params.dictType = it.remark;
      } else {
        // return
        this.params1.dictValue = it.dictValue;
        this.params1.dictType = it.remark;
        if (this.params1.dictValue == 13) {
          // 单位报告
          this.$router.push("/report/report-company");
          this.resetParams();
        }
      }
    },

    cancle() {
      this.resetSearch();
      this.getList();
    },
    //图片格式转换方法

    // 生成二维码

    getDatas() {
      this.areaList = [];
      this.$get(`/system/dict/data/FireList`, this.leftParams).then((res) => {
        // console.log(res,1111111111);
        this.areaList = res.data;
      });
      if (this.tabList[this.nowIndex].id == 0) {
      } else {
      }
    },
    getList() {},
    getWWList() {
      this.$get("/inspection/wenwuInspectionPoint/list", this.params1).then(
        (res) => {
          this.list1 = res.rows;
          this.total1 = res.count;
        }
      );
    },
    pageChange(val) {
      this.params.page = val;
      this.getList();
    },
    searchSubmit() {
      this.$refs.searchForm
        .getData()
        .then((data) => {
          log(data);
          var obj = { ...this.params, ...data };
          this.params = obj;
          this.params.page = 1;
          this.getList();
          this.showDia = false;
          // this.resetSearch()
        })
        .catch((e) => {});
    },
    //  打印

    resetSearch() {
      this.$refs.searchForm.reset();
      this.params = {
        ...this.params,

        c_point_name: "",
        c_point_number: "",
        c_point_addr: "",
        c_point_area: "",
      };
    },
    getOne(v) {
      this.cpNum = v;
    },
    getUnit(v) {
      this.cpNum = v;
    },
  },

  beforeRouteLeave(to, from, next) {
    this.showComp = false;

    next();
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.showComp = true;
      console.log(vm, from, 4444444444444);
      vm.resetParams();
      if (from.path == "/company/company-add") {
        if (vm.$route.query.view) {
          console.log(1111);
          vm.changeTab(1);
        } else {
          console.log("zou");
          vm.changeTab(0);
        }
      }

      //     //因为当钩子执行前，组件实例还没被创建
      //     // vm 就是当前组件的实例相当于上面的 this，所以在 next 方法里你就可以把 vm 当 this 来用了。
      //     console.log(vm);//当前组件的实例
    });
  },
  watch: {
    showDia1(val) {
      console.log(val);
      if (!val) {
        document.getElementById("qrcode").innerHTML = "";
      }
    },
    // nowIndex(){
    //   this.list = []

    //   this.getDatas()
    // },
    cpNum() {
      // console.log('zoulema');
      this.list = [];
      this.params.c_company_num = this.cpNum;
      this.params.page = 1;
      this.params1.companyNum = this.cpNum;
      this.params1.pageNum = 1;
      this.getDatas();
    },
  },
};
</script>

<style scoped>
.el-dialog .el-dialog__body {
  padding: 0 !important;
}
.mark {
  background: #3d62de;
  color: #fff;
}
.container-list {
  height: 100%;
}
.common-list {
  height: 39.5vw;
}
.areaitem {
  height: 30px;
  width: 100%;
  text-align: center;
  display: flex;
  padding: 20px;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  border-bottom: 1px groove;
  margin-right: 20px;
  cursor: pointer;
}
.choose {
  border-radius: 10px;
  min-width: 200px;
  width: 20%;

  height: 39.5vw;

  border: 1px solid #ccc;
}
</style>
